import { rechargeApiRequest } from '../utils/request.js';

async function getPlan(session, id) {
  const { plan } = await rechargeApiRequest(
    "get",
    `/plans`,
    {
      id
    },
    session
  );
  return plan;
}
function listPlans(session, query) {
  return rechargeApiRequest("get", `/plans`, { query }, session);
}

export { getPlan, listPlans };
//# sourceMappingURL=plan.js.map
